<template>
    <div id="DatosPedidoAnonimo">
        
        <h4 class="mb-3">
            Al comprar sin iniciar sesión, debes definir los siguientes datos
        </h4>
        
        <b-form @submit="emitSubmit" @reset="onReset" v-if="show">
            <b-row>
                <b-col>
                    <b-form-group id="input-group-1" label="Nombre(s):" label-for="input-1">
                        <b-form-input id="input-1" v-model="form.nombre" type="text" placeholder="Ingrese su(s) nombre(s)"
                            required></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group id="input-group-2" label="Apellidos:" label-for="input-2">
                        <b-form-input id="input-2" v-model="form.apellidos" type="text" placeholder="Ingrese sus apellidos"
                            required></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group id="input-group-3" label="Correo Electrónico:" label-for="input-3">
                <b-form-input id="input-3" v-model="form.email" type="email" placeholder="Ingrese su correo electrónico"
                    required></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-4" label="Teléfono:" label-for="input-4">
                <b-form-input id="input-4" v-model="form.telefono" type="tel" placeholder="Ingrese su número telefónico"
                    required></b-form-input>
            </b-form-group>

            <template v-if="!hideButtons">
                <b-button type="submit" variant="primary">Enviar</b-button>
                <b-button type="reset" variant="danger">Limpiar</b-button>
            </template>
        </b-form>
    </div>
</template>

<script>
import _ from 'lodash'
import {
    BForm,
    BFormGroup,
    BFormInput,
    BButton
} from 'bootstrap-vue'

export default {
    name: 'DatosPedidoAnonimo',
    components: {
        BForm,
        BFormGroup,
        BFormInput,
        BButton
    },
    props: {
        hideButtons: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            form: {
                nombre: '',
                apellidos: '',
                email: '',
                telefono: ''
            },
            show: true
        }
    },
    methods: {
        emitSubmit(event) {
            if (event)
                event.preventDefault()
            return _.clone(this.form)
        },
        onReset(event) {
            if (event)
                event.preventDefault()
            this.form.nombre = ''
            this.form.apellidos = ''
            this.form.email = ''
            this.form.telefono = ''
        }
    }
}
</script>

<style>
#DatosPedidoAnonimo {
    /* max-width: 500px; */
    margin: 0 auto;
    padding: 20px;
}
</style>